import { getNotificationStatus, showNotification } from "@/lib/notifications";
import { getInputUndLabel } from "@/lib/util";
import { shareCart } from "@/lib/warenkorb";
import $ from "jquery";

const $shareCartContainer = $("#share-cart");
const $shareCartButton = $("#shared-cart-senden");

$shareCartButton.on("click", async (_) => {
	const empfaenger = getInputUndLabel($shareCartContainer, "EmpfaengerSharedCart");
	const name = getInputUndLabel($shareCartContainer, "NameSharedCart");
	const captcha = getInputUndLabel($shareCartContainer, "MitteilungSharedCart");

	let data = await shareCart(empfaenger.input.val() as string, name.input.val() as string, captcha.input.val() as string);
	showNotification(getNotificationStatus(data.fehler), data.status);

	if (data.fehler) return;

	// Eingaben zurücksetzen
	empfaenger.label.removeClass("is-invalid");
	empfaenger.input.val("");
	name.label.removeClass("is-invalid");
	name.input.val("");

	// Fancybox schließen
	$("#fancybox-data-closebutton").trigger("click");
});
